/**
 * Tooltip glass FLUA para Recharts.
 * Use como <Tooltip content={<ChartTooltipFlua />} />.
 * Aceita `valueFormatter(value, name)` para customizar formatação.
 */
export function ChartTooltipFlua({ active, payload, label, valueFormatter }) {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div
      className="rounded-lg border border-primary/30 bg-card/90 backdrop-blur-xl px-3 py-2.5 shadow-xl shadow-primary/20 text-xs min-w-[140px]"
      data-testid="chart-tooltip-flua"
    >
      {label !== undefined && label !== "" && (
        <div className="font-heading font-semibold text-foreground mb-1.5 truncate">{String(label)}</div>
      )}
      <div className="space-y-1">
        {payload.map((p, i) => {
          const displayValue = valueFormatter ? valueFormatter(p.value, p.name, p) : p.value;
          return (
            <div key={i} className="flex items-center justify-between gap-3">
              <span className="flex items-center gap-1.5 text-muted-foreground">
                <span
                  className="inline-block w-2 h-2 rounded-full"
                  style={{ background: p.color || "hsl(var(--primary))" }}
                />
                <span className="truncate">{p.name}</span>
              </span>
              <span className="tabular-nums font-semibold text-foreground">{displayValue}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/**
 * <defs><FluaBarGradient id="flua-bar" /></defs>
 * <Bar fill="url(#flua-bar)" />
 * Devolve um linearGradient vertical primary → primary transparente.
 */
export function FluaBarGradient({ id = "flua-bar", from = "hsl(var(--primary))", to = "hsl(var(--primary) / 0.35)" }) {
  return (
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={from} stopOpacity={1} />
        <stop offset="100%" stopColor={to} stopOpacity={0.6} />
      </linearGradient>
    </defs>
  );
}

/** Props padrão pra CartesianGrid — pontilhado com cor de border do tema. */
export const fluaGridProps = {
  strokeDasharray: "3 3",
  stroke: "hsl(var(--border))",
  strokeOpacity: 0.6,
};

/** Props padrão pra XAxis/YAxis — tipografia + cor coerentes com o tema. */
export const fluaAxisProps = {
  tick: { fontSize: 11, fill: "hsl(var(--muted-foreground))" },
  tickLine: false,
  axisLine: { stroke: "hsl(var(--border))", strokeOpacity: 0.5 },
};

export default ChartTooltipFlua;
